import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ReactGA from 'react-ga4';
import querystring from 'querystring';
import isEmpty from 'lodash.isempty';
import { isFunction } from 'lodash';
import dayjs from 'dayjs';

import { clientShopId } from 'config/const';
import { useAuth } from 'providers/Auth';
import { useShop } from 'providers/Shop';

function WithTracker({ children, ga }) {
  const { auth } = useAuth();
  const lineId = auth.userId;

  const shopId = clientShopId;

  useEffect(() => {
    if (!lineId || !ga) return;
    const page = `/shop/${shopId}/user/${lineId}/action/${ga}`;

    ReactGA.send({
      hitType: 'pageview',
      page,
      userId: `shop/${shopId}/user/${lineId}`,
      referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
      title: ga,
    });
  }, [lineId, ga]);

  return <>{children}</>;
}

function WithIdTracker({ children, ga, idKey, itemKey, getTitle, getPage }) {
  const { auth } = useAuth();
  const params = useParams();
  const shop = useShop();
  const id = params[idKey];
  const items = shop[itemKey];
  const lineId = auth.userId;
  const item = items.find((item) => String(item.id) === String(id));
  const shopId = clientShopId;

  useEffect(() => {
    if (!lineId || !ga || isEmpty(item)) return;

    let page = `/shop/${shopId}/user/${lineId}/action/${ga}`;
    let title = `${ga}/${item.id}`;
    if (isFunction(getPage)) page = getPage(shopId, lineId, item);
    if (isFunction(getTitle)) title = getTitle(shopId, lineId, item);

    ReactGA.send({
      hitType: 'pageview',
      page,
      userId: `shop/${shopId}/user/${lineId}`,
      referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
      title,
    });
  }, [lineId, ga, item]);

  return <>{children}</>;
}

function WithProductTracker({ children, ga, idKey, itemKey }) {
  const { auth } = useAuth();
  const params = useParams();
  const shop = useShop();
  const id = params[idKey];
  const items = shop[itemKey];
  const lineId = auth.userId;
  const item = items.find((item) => String(item.id) === String(id));
  const shopId = clientShopId;

  useEffect(() => {
    if (!lineId || !ga || isEmpty(item)) return;

    const userId = `shop/${shopId}/user/${lineId}`;
    const pageUrl = `https://linebot/shop/${shopId}/user/${lineId}`;
    const unixTime = Math.floor(Date.now() / 1000);

    let title = ga;
    let page = `${pageUrl}/action/${ga}?${querystring.stringify({
      productId: item.id,
    })}`;

    ReactGA.send({
      hitType: 'pageview',
      page,
      shop_id: shopId,
      userId,
      referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
      title,
      page_location: page,
      page_referer: pageUrl,
      content_group_1: item.id ? `product_id=${item.id}` : undefined,
      unix_time: unixTime,
      date_hour_minute: dayjs().format('YYYYMMDDHHmm'),
    });
  }, [lineId, ga, item]);

  return <>{children}</>;
}

export default {
  WithTracker,
  WithIdTracker,
  WithProductTracker,
};
